import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

import { MotivoIndisponibilidadeService } from '../services/motivo-indisponibilidade.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-motivos-indisponibilidade',
	templateUrl: './motivos-indisponibilidade.component.html',
	styleUrls: ['./motivos-indisponibilidade.component.css'],
	animations: [loadingFade, modal, alert]
})
export class MotivosIndisponibilidadeComponent implements OnInit {
	public loading = false;
	public motivos = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	constructor(private motivoIndispSvc: MotivoIndisponibilidadeService,) { }

	ngOnInit() {
		this.pegaMotivosDespesa();
	}

	pegaMotivosDespesa() {
		this.motivos = [];
		this.loading = true;
		this.motivoIndispSvc.getMotivosIndisponibilidade().then((data: any[]) => {
			this.motivos = data;
			this.count = this.motivos.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaMotivo(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.motivoIndispSvc.apagaMotivoIndisponibilidade(id).then((data) => {
					this.pegaMotivosDespesa();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}
}
